import { render, staticRenderFns } from "./RcnTemplate.vue?vue&type=template&id=a6d74cce&"
import script from "./RcnTemplate.vue?vue&type=script&lang=js&"
export * from "./RcnTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports